<template>
  <app-content>
    <h1>Vilkår for brug af Tripply</h1>

    <p>
      Psst... Det er en stor ansvarsfraskrivelse krydret med lidt "Copyright"
      tekst så du ikke må kopiere vores hårdt tjente arbejde.
    </p>

    <h3>1. Betingelser</h3>

    <p>
      Ved at tilgå dette websted, der er tilgængeligt gennem www.tripply.dk,
      accepterer du at være bundet af disse brugsvilkår og er enig i, at du er
      ansvarlig for aftalen med alle relevante lokale love. Hvis du er uenig i
      nogen af disse vilkår, er det forbudt tilgå dette websted. Materialerne
      på dette websted er beskyttet ved ophavsret og varemærkeret.
    </p>

    <h3>2. Licens for anvendelse</h3>

    <p>
      Der gives tilladelse til midlertidigt at downloade en kopi af materialet
      på Tripplys websted kun til personlig, ikke-kommerciel forbigående
      visning. Dette er tildelingen af en licens, ikke en overførsel af titel,
      og under dette licens du muligvis ikke:
    </p>

    <p>
    <ul>
      <li>ændre eller kopiere materialerne;</li>
      <li>
        bruge materialerne til ethvert kommercielt formål eller til offentlig
        visning;
      </li>
      <li>
        forsøg på at "reverse engineering" af enhver software indeholdt på
        Tripplys websted;
      </li>
      <li>
        fjerne ophavsret eller andre proprietære notationer fra materialet;
        eller
      </li>
      <li>
        overføre materialerne til en anden person eller "spejle" materialerne på
        enhver anden server.
      </li>
    </ul>
    </p>

    <p>
      Dette giver Tripply mulighed for at opsige ved overtrædelser af nogen af
      disse begrænsninger. Efter opsigelse ophører din synsret også og du skal
      destruere alt downloadet materiale i din besiddelse uanset om det er trykt
      eller elektronisk. Disse servicevilkår har været oprettet ved hjælp af
      <a href="https://www.termsofservicegenerator.net"
        >Terms Of Service Generator</a
      >
      og
      <a href="https://www.generateprivacypolicy.com"
        >Privacy Policy Generator</a
      >.
    </p>

    <p>
      Som betalnde bruger er det ganske tilladt at benytte Tripply.dk's
      funktioner, så som eksporter til excel og udskriv rute til kommercielle og
      offentlige formål.
    </p>

    <h3>3. Disclaimer</h3>

    <p>
      Alt materiale på Tripplys websted leveres "som det er". Tripply giver
      ingen garantier, må det udtrykkes eller underforstået, negerer derfor alle
      andre garantier. Desuden fremsætter Tripply ingen udtalelser om
      nøjagtigheden eller pålideligheden af brugen af materialerne på dets
      Hjemmeside eller på anden måde relateret til sådant materiale eller andre
      sider, der er linket til dette websted.
    </p>

    <h3>4. Begrænsninger</h3>

    <p>
      Tripply eller dets leverandører kan ikke holdes ansvarlige for skader, der
      opstår ved brug eller manglende evne til at bruge materialerne på
      Tripply's Hjemmeside, selvom Tripply eller en bemyndigende repræsentant
      for dette websted er mundtligt eller skriftligt underrettet om muligheden
      for sådan skade. Nogle jurisdiktioner tillader ikke begrænsninger af
      underforståede garantier eller begrænsninger i erstatningsansvar for
      utilsigtede skader, er disse begrænsninger muligvis ikke gælder for dig.
    </p>

    <h3>5. Revissioner and Errata</h3>

    <p>
      Materialet, der vises på Tripplys websted, kan omfatte teknisk,
      typografiske eller fotografiske fejl. Tripply vil ikke love at nogen af
      materialerne på dette websted er nøjagtige, komplette eller aktuelle.
      Tripply kan når som helst ændre materialet på sit websted uden varsel.
      Tripply forpligter sig ikke til at opdatere materialer.
    </p>

    <h3>6. Links</h3>

    <p>
      Tripply har ikke gennemgået alle de sider, der er linket til sit websted,
      og er ikke ansvarlig for indholdet af et sådant linket websted.
      Tilstedeværelsen af enhver link betyder ikke, at Tripply godkender
      webstedet. Brug af enhver linket websted er på brugerens egen risiko.
    </p>

    <h3>7. Webstedet ændringer af brugsbetingelserne</h3>

    <p>
      Tripply kan revidere disse brugsbetingelser til sit websted når som helst
      uden forudgående varsel. Ved at bruge dette websted accepterer du at være
      bundet af aktuelle version af disse vilkår og betingelser for brug.
    </p>

    <h3>8. Dine privatlivsvilkår</h3>

    <p>
      <router-link to="/Privacy"
        >Venligst læs vores privatlivsvilkår.
      </router-link>
    </p>

    <h3>9. Gældene lovgivning</h3>

    <p>
      Ethvert krav relateret til Tripplys websted er underlagt lovgivningen i dk
      uden hensyn til dets lovbestemmelser.
    </p>
    <!--
    <h1>Website Terms and Conditions of Use</h1>

    <h3>1. Terms</h3>

    <p>
      By accessing this Website, accessible from www.tripply.dk, you are
      agreeing to be bound by these Website Terms and Conditions of Use and
      agree that you are responsible for the agreement with any applicable local
      laws. If you disagree with any of these terms, you are prohibited from
      accessing this site. The materials contained in this Website are protected
      by copyright and trade mark law.
    </p>

    <h3>2. Use License</h3>

    <p>
      Permission is granted to temporarily download one copy of the materials on
      Tripply's Website for personal, non-commercial transitory viewing only.
      This is the grant of a license, not a transfer of title, and under this
      license you may not:
    </p>

    <p>
    <ul>
      <li>modify or copy the materials;</li>
      <li>
        use the materials for any commercial purpose or for any public display;
      </li>
      <li>
        attempt to reverse engineer any software contained on Tripply's Website;
      </li>
      <li>
        remove any copyright or other proprietary notations from the materials;
        or
      </li>
      <li>
        transferring the materials to another person or "mirror" the materials
        on any other server.
      </li>
    </ul>
    </p>

    <p>
      This will let Tripply to terminate upon violations of any of these
      restrictions. Upon termination, your viewing right will also be terminated
      and you should destroy any downloaded materials in your possession whether
      it is printed or electronic format. These Terms of Service has been
      created with the help of the
      <a href="https://www.termsofservicegenerator.net"
        >Terms Of Service Generator</a
      >
      and the
      <a href="https://www.generateprivacypolicy.com"
        >Privacy Policy Generator</a
      >.
    </p>

    <p>
      As a paying customer you are in your good right to use functions provided
      by the tripply webpage such as print and export to excel for commercial
      and public purposes.
    </p>

    <h3>3. Disclaimer</h3>

    <p>
      All the materials on Tripply’s Website are provided "as is". Tripply makes
      no warranties, may it be expressed or implied, therefore negates all other
      warranties. Furthermore, Tripply does not make any representations
      concerning the accuracy or reliability of the use of the materials on its
      Website or otherwise relating to such materials or any sites linked to
      this Website.
    </p>

    <h3>4. Limitations</h3>

    <p>
      Tripply or its suppliers will not be hold accountable for any damages that
      will arise with the use or inability to use the materials on Tripply’s
      Website, even if Tripply or an authorize representative of this Website
      has been notified, orally or written, of the possibility of such damage.
      Some jurisdiction does not allow limitations on implied warranties or
      limitations of liability for incidental damages, these limitations may not
      apply to you.
    </p>

    <h3>5. Revisions and Errata</h3>

    <p>
      The materials appearing on Tripply’s Website may include technical,
      typographical, or photographic errors. Tripply will not promise that any
      of the materials in this Website are accurate, complete, or current.
      Tripply may change the materials contained on its Website at any time
      without notice. Tripply does not make any commitment to update the
      materials.
    </p>

    <h3>6. Links</h3>

    <p>
      Tripply has not reviewed all of the sites linked to its Website and is not
      responsible for the contents of any such linked site. The presence of any
      link does not imply endorsement by Tripply of the site. The use of any
      linked website is at the user’s own risk.
    </p>

    <h3>7. Site Terms of Use Modifications</h3>

    <p>
      Tripply may revise these Terms of Use for its Website at any time without
      prior notice. By using this Website, you are agreeing to be bound by the
      current version of these Terms and Conditions of Use.
    </p>

    <h3>8. Your Privacy</h3>

    <p>
      <router-link to="/Privacy">Please read our Privacy Policy. </router-link>
    </p>

    <h3>9. Governing Law</h3>

    <p>
      Any claim related to Tripply's Website shall be governed by the laws of dk
      without regards to its conflict of law provisions.
    </p>
    -->
  </app-content>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import AppContent from "@/components/layout/AppContent.vue";

export default defineComponent({
  name: "Terms of Service",
  components: { AppContent },
});
</script>
